export const BUTTON_SCROLL_TOP_EVENTS = {
  SELCET_WEB_TOP_EVENTS: "web_select_top_catalogue",
};
